<h2 class="section-title" nz-typography>
  {{ getStrPath("LINE_INFO.TITLE") | translate }}
</h2>

<div class="list-wrapper">
  <div nz-row class="list-item" nzAlign="top" *ngIf="line.lineId">
    <div class="list-title">
      {{ getStrPath("LINE_INFO.LINE_ID") | translate }}:
    </div>
    <div class="list-value">
      {{ line.lineId }}
    </div>
  </div>
  <div
    nz-row
    class="list-item"
    nzAlign="top"
    *ngIf="line.phoneNumber?.temporaryPhoneNumber"
  >
    <div class="list-title">
      {{ getStrPath("LINE_INFO.TEMPORARY_PHONE_NUMBER") | translate }}:
    </div>
    <div class="list-value">
      {{ line.phoneNumber?.temporaryPhoneNumber }}
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top" *ngIf="line.phoneNumbers?.length">
    <div class="list-title">
      {{ getStrPath("LINE_INFO.CURRENT_PHONE_NUMBER") | translate }}:
    </div>
    <div class="list-value">
      <ng-container *ngFor="let phoneNumber of line.phoneNumbers">
        <div>{{ phoneNumber.phoneNumber }}</div>
      </ng-container>
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top" *ngIf="line.statusReason">
    <div class="list-title">
      {{ getStrPath("LINE_INFO.ACTIVATION_FAILURE_REASON") | translate }}:
    </div>
    <div class="list-value">
      <div>{{ line.statusReason.reason }}</div>
      <div>
        {{ line.statusReason.errorCode }} -
        {{ line.statusReason.retryCondition }}
      </div>
    </div>
  </div>

  <div
    nz-row
    class="list-item"
    nzAlign="top"
    *ngIf="line.phoneNumber?.portedTs"
  >
    <div class="list-title">
      {{ getStrPath("LINE_INFO.NUMBER_PORT_DATE") | translate }}:
    </div>
    <div class="list-value">
      {{ line.phoneNumber?.portedTs | localizedDate: "MMM d, y, h:mm a" }}
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top" *ngIf="line.activationTs">
    <div class="list-title">
      {{ getStrPath("LINE_INFO.ACTIVATION_DATE") | translate }}:
    </div>
    <div class="list-value">
      {{ line.activationTs | localizedDate: "MMM d, y, h:mm a" }}
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top">
    <div class="list-title">
      {{ getStrPath("LINE_INFO.ACTIVATE_ON_ATTACH") | translate }}:
    </div>
    <div class="list-value">
      {{ activateOnAttach }}
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top">
    <div class="list-title">
      {{ "GLOBAL_TERMS.LINES.PERSISTENCY.TITLE" | translate }}:
    </div>
    <div class="list-value">
      {{ line.persistent || false }}
    </div>
  </div>
</div>

<ng-container *ngIf="sim">
  <h2 class="section-title" nz-typography>
    {{ getStrPath("SIM_INFO.TITLE") | translate }}
  </h2>

  <div class="list-wrapper">
    <div nz-row class="list-item" nzAlign="top" *ngIf="sim.iccid">
      <div class="list-title">
        {{ getStrPath("SIM_INFO.CURRENT_ICCID") | translate }}:
      </div>
      <div class="list-value">
        {{ sim.iccid }}
      </div>
    </div>
    <div nz-row class="list-item" nzAlign="top" *ngIf="sim.swappedSimIccid">
      <div class="list-title">
        {{ getStrPath("SIM_INFO.SWAPPED_ICCID") | translate }}:
      </div>
      <div class="list-value">
        {{ sim.swappedSimIccid }}
      </div>
    </div>
    <div nz-row class="list-item" nzAlign="top" *ngIf="sim.imsis.length">
      <div class="list-title">
        {{ getStrPath("SIM_INFO.IMSI") | translate }}:
      </div>
      <div class="list-value">
        <ng-container *ngFor="let imsi of sim.imsis; let i = index">
          {{ imsi }}
        </ng-container>
      </div>
    </div>
    <div nz-row class="list-item" nzAlign="top" *ngIf="sim.distributorId">
      <div class="list-title">
        {{ getStrPath("SIM_INFO.DISTRIBUTOR") | translate }}:
      </div>
      <div class="list-value">
        <span
          nz-typography
          nzCopyable
          [nzCopyText]="sim.distributorId"
          [nzCopyTooltips]="[
            'BUTTON.COPY' | translate,
            'BUTTON.COPIED' | translate
          ]"
          [nzCopyIcons]="[copyIconTpl, copiedIconTpl]"
        >
          {{
            sim.distributorId
              | ValueComputer: "VALUE_COMMON_DISTRIBUTOR":sim
              | async
          }}
        </span>
      </div>
    </div>
    <!-- <div nz-row class="list-item" nzAlign="top" *ngIf="sim.serviceOrder">
    <div class="list-title">
      {{ getStrPath("SIM_INFO.PURCHASE_ORDER") | translate }}:
    </div>
    <div class="list-value">
      {{ sim.serviceOrder }}
    </div>
  </div> -->
    <div nz-row class="list-item" nzAlign="top" *ngIf="sim.creationTs">
      <div class="list-title">
        {{ getStrPath("SIM_INFO.CREATED_DATE") | translate }}:
      </div>
      <div class="list-value">
        {{ sim.creationTs | localizedDate: "MMM d, y, h:mm a" }}
      </div>
    </div>
    <div nz-row class="list-item" nzAlign="top" *ngIf="sim.updateTs">
      <div class="list-title">
        {{ getStrPath("SIM_INFO.UPDATED_DATE") | translate }}:
      </div>
      <div class="list-value">
        {{ sim.updateTs | localizedDate: "MMM d, y, h:mm a" }}
      </div>
    </div>
    <div nz-row class="list-item" nzAlign="top" *ngIf="sim.manufacturer">
      <div class="list-title">
        {{ getStrPath("SIM_INFO.SIM_MANUFACTURER") | translate }}:
      </div>
      <div class="list-value">
        {{ sim.manufacturer }}
      </div>
    </div>
    <div nz-row class="list-item" nzAlign="top" *ngIf="sim.simType">
      <div class="list-title">
        {{ getStrPath("SIM_INFO.SIM_TYPE") | translate }}:
      </div>
      <div class="list-value">
        {{ sim.simType }}
      </div>
    </div>
  </div>
</ng-container>

<h2 class="section-title" nz-typography *ngIf="device">
  {{ getStrPath("DEVICE_INFO.TITLE") | translate }}
</h2>
<div class="list-wrapper" *ngIf="device">
  <div nz-row class="list-item" nzAlign="top" *ngIf="device.tac">
    <div class="list-title">
      {{ getStrPath("DEVICE_INFO.TAC") | translate }}:
    </div>
    <div class="list-value">
      {{ device.tac }}
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top" *ngIf="device.manufacturer">
    <div class="list-title">
      {{ getStrPath("DEVICE_INFO.DEVICE_MANUFACTURER") | translate }}:
    </div>
    <div class="list-value">
      {{ device.manufacturer }}
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top" *ngIf="device.model">
    <div class="list-title">
      {{ getStrPath("DEVICE_INFO.DEVICE_MODEL") | translate }}:
    </div>
    <div class="list-value">
      {{ device.model }}
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top" *ngIf="device.latestAttachTs">
    <div class="list-title">
      {{ getStrPath("DEVICE_INFO.LATEST_ATTACH_TS") | translate }}:
    </div>
    <div class="list-value">
      {{ device.latestAttachTs | date }}
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top">
    <div class="list-title">
      {{ getStrPath("DEVICE_INFO.VOLTE") | translate }}:
    </div>
    <div class="list-value">
      {{
        "GLOBAL_TERMS." +
          (device.capabilities.volte ? "SUPPORTED" : "NOT_SUPPORTED")
          | translate
      }}
    </div>
  </div>
  <div nz-row class="list-item" nzAlign="top">
    <div class="list-title">
      {{ getStrPath("DEVICE_INFO.BAND_28") | translate }}:
    </div>
    <div class="list-value text-capitalized">
      {{
        "GLOBAL_TERMS." +
          (device.capabilities.band28 ? "SUPPORTED" : "NOT_SUPPORTED")
          | translate
      }}
    </div>
  </div>
</div>

<ng-template #copyIconTpl>
  <i class="fal fa-copy"></i>
</ng-template>

<ng-template #copiedIconTpl>
  <i class="fal fa-check"></i>
</ng-template>
